import styled from 'styled-components'

import {
  PRIMARY_NORMAL_COLOR,
} from '@CSSVars/colors'


export const _DividerWrap = styled.div`
  position: relative;
  padding: 0 15px;
  background-color: white;
`

export const _Divider = styled.div`
  position: relative;
  padding: 16px 0 0 0;
  color: ${PRIMARY_NORMAL_COLOR};
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
`

export const _DividerIcon = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;

  svg {
    fill: ${PRIMARY_NORMAL_COLOR};
    path {
      fill: ${PRIMARY_NORMAL_COLOR};
    }
  }


`

export const _DividerTitle = styled.div`
  line-height: 20px;
  ${({ hasIcon }) => (
    hasIcon ?
      `
        padding-left: 2.5rem;
        font-weight: bold;
      ` : ''
  )}
`
